import React, { useEffect, useRef, useState } from 'react'
import { connect } from "react-redux";
import store from "../../../store/store";
import TopOfAddStepTables from '../../../CellStepManagement/components/TopOfAddStepTables';
import PaginationBlock from '../PaginationBlock';
import { Card, Divider } from '@mui/material';
import SearchIcon from "@mui/icons-material/Search";
import TableCardsWrapper from './reusableCachePgStepper/TableCardsWrapper';
import StimSearchTableTop from './reusableCachePgStepper/tableComps/StimSearchTableTop';
import DataService from '../../../common/services/dataService';
import { CellStepManagementOperations } from "../../../CellStepManagement/duck/index";
import { useHistory } from "react-router-dom";
import openMobilePreview from './openMobilePreview';
import LumenElementPanel from './lumenPanel/LumenElementPanel';
import { MESSAGES, sendToFrame, toCssOverrides } from '../../ultis/lumenPanelProtocol';


function BuildPgMain(
    props

) {
    const { pg,
        changeModalView,
        stepType,
        studyId,
        onSelectItem,
        rowsPerPage,
        currentPage,
        toggleItem,
        onSearch,
        setHasSearched,
        resetStateToLoading,
        hasSearched,
        loading,
        resultCount,
        onPageChange,
        onRowsPerPageChange,
        clearPrimarySelection,
        onAddAll,
        cellId,
        iframeStep,
        updateLoading,
    } = props

    const [stims, setStims] = useState([]);
    // increments whenever a stim is assigned; TableCardsWrapper watches it to work out
    // which slot to offer next
    const [card, setCard] = useState(0);
    const [displayPreview, setDisplayPreview] = useState(false);
    const [selectedIds, setSelectedIds] = useState(null);
    const [src, setSrc] = useState(pg.cached_source)
    const [stimsLoaded, setStimsLoaded] = useState(false)
    const [updateStep, setUpdateStep] = useState(false)
    const [availableStims, setAvailableStims] = useState([])
    const [filterParam, setFilterParam] = useState(false)
    const [searched, SetSearched] = useState('Please Search')
    const [resultPg, setResultPg] = useState(false)
    const [paginationState, setPaginationState] = useState()
    const [resultsNumber, setResultsNumber] = useState(false)
    const [cachePgStep, setCachePgStep] = useState(null)

    const [styling, setStyling] = useState(false)

    const { getStimSteps } = DataService



    function triggerStimsLoaded() {
        setStimsLoaded(!stimsLoaded)
    }

    function hasAnyFilter(params) {
        return Boolean(params && Array.isArray(params.filters) && params.filters.length)
    }

    function createdFilteredStimList(filter) {
        // Removing the last filter must not reach the endpoint - it 500s on an empty filter
        // set. Fall back to the "Search for a Stim" prompt instead, which is the same state
        // the panel starts in, and drop any results from the previous search.
        if (!hasAnyFilter(filter)) {
            setHasSearched(false)
            setAvailableStims([])
            setPaginationState(undefined)
            setFilterParam(false)
            SetSearched('Please Search')
            return
        }

        // every dropdown search funnels through here, so flag the search and show the
        // spinner in one place - otherwise the results area stays on the "Search for a
        // Stim" placeholder because hasSearched was only ever set by the text field.
        // filter is a fresh object each call, so re-picking the same option still
        // changes the reference and re-runs the getStims effect below.
        setHasSearched(true)
        resetStateToLoading()
        setFilterParam(filter)
    }

    useEffect(() => {
        setSelectedIds(pg.id)
    }, [])

    useEffect(() => {
        if (resultPg) {
            nextPg(resultPg)
        }
    }, [resultPg])

    useEffect(() => {
        if (resultsNumber) {
            resultsPerPg(resultsNumber)
        }
    }, [
        resultsNumber
    ])


    async function resultsPerPg(resultsNumber) {

        // nothing to page through without a filter set, and an empty one 500s
        if (!hasAnyFilter(filterParam)) {
            return
        }

        // carries the whole filters array through - reading group/filter here dropped every
        // filter the moment the payload moved to a filters array
        const { page_num, filters } = filterParam

        const updatedDataObj = { results_per_page: resultsNumber, filters, page_num }

        const res = await getStimSteps(studyId, updatedDataObj)
        if (res.data.data.length > 0) {
            const { results_per_page, result_count, total_page_num, page_num } = res.data
            console.log('return')
            setAvailableStims(res.data.data)
            setPaginationState({ results_per_page, result_count, total_page_num, page_num })
        } else {
            setAvailableStims([])
            SetSearched('No results to show please search again')
        }
    }

    async function nextPg(newPg) {

        // nothing to page through without a filter set, and an empty one 500s
        if (!hasAnyFilter(filterParam)) {
            return
        }

        const { results_per_page, filters } = filterParam

        const updatedDataObj = { results_per_page, filters, page_num: newPg }

        const res = await getStimSteps(studyId, updatedDataObj)
        if (res.data.data.length > 0) {
            const { results_per_page, result_count, total_page_num, page_num } = res.data
            console.log('return')
            setAvailableStims(res.data.data)
            setPaginationState({ results_per_page, result_count, total_page_num, page_num })
        } else {
            setAvailableStims([])
            SetSearched('No results to show please search again')
        }
    }

    async function getStims(data) {
        if (data) {
            const res = await getStimSteps(studyId, data)

            if (res.data.data.length > 0) {
                const { results_per_page, result_count, total_page_num, page_num } = res.data
                setAvailableStims(res.data.data)
                setPaginationState({ results_per_page, result_count, total_page_num, page_num })
                updateLoading()
            } else {
                setAvailableStims([])
                SetSearched('No results to show please search again')
                // clear loading here too, or an empty result leaves the spinner
                // running forever instead of showing the message above
                updateLoading()
            }
        }
    }
    useEffect(() => {
        getStims(filterParam)
    }, [filterParam])

    function togglePreview() {
        setDisplayPreview(!displayPreview)
    }


    const inputRef = useRef(null);

    const [showLumenPanel, setShowLumenPanel] = useState(false)
    // keyed by the element key the cache page assigns, see lumenPanelProtocol
    const [lumenOverrides, setLumenOverrides] = useState({})

    // Push the overrides into the page whenever they change, so an edit shows immediately.
    function applyLumenOverrides(next) {
        setLumenOverrides(next)

        // What gets saved is only the altered properties, written as real CSS - so the study
        // environment can hand each pair straight to element.style.setProperty() without
        // knowing anything about this panel's vocabulary.
        //
        //   panel state                         saved
        //   offsetX: 56                   ->    transform: 'translateX(56px)'
        //   backgroundColor: '#726e6f'    ->    'background-color': '#726e6f'
        //   hidden: true                  ->    display: 'none'
        //   color: '' (untouched)         ->    omitted
        //
        // The preview is untouched: setLumenOverrides and the frame message below still
        // carry the full panel-shaped object, because the listener inside the cache page
        // speaks that vocabulary.
        setStyling(toCssOverrides(next))

        sendToFrame(inputRef.current, MESSAGES.APPLY_OVERRIDES, next)
    }

    // The overrides are inline styles inside the cache page, so any reload wipes them - a
    // stim being assigned reloads the iframe too. Re-send on every load so the page always
    // re-renders with the changes still applied rather than silently reverting.
    function handleIframeLoad() {
        if (Object.keys(lumenOverrides).length) {
            sendToFrame(inputRef.current, MESSAGES.APPLY_OVERRIDES, lumenOverrides)
        }
    }

    /*
     * Assigns a stim to an ad slot. `position` is the slot letter (a, b, c ...).
     *
     * One stim per slot, enforced here. The old version only skipped the append when the
     * SAME id was already in the SAME slot, so choosing a different stim for a slot that was
     * already filled appended a second entry - two stims for one slot, and because that
     * inflated stims.length the completion gate then reported the page finished with another
     * slot still empty.
     *
     * Its removal filter also used `&&` where it needed `||`: keeping only rows where
     * `id !== stim && position !== i` dropped every other slot sharing that id, which wiped
     * all the blanked slots at once (they all carry id 0).
     */
    const addStims = ((stim, position) => {

        setCard(card + 1)

        setStims((prev) => {
            const alreadyInThisSlot = prev.some(
                (existing) => existing.id === stim && existing.position === position
            )

            // picking the same stim again in the same slot clears that slot
            if (alreadyInThisSlot) {
                return prev.filter(
                    (existing) => !(existing.id === stim && existing.position === position)
                )
            }

            // replace whatever occupies this slot rather than adding alongside it
            return [
                ...prev.filter((existing) => existing.position !== position),
                { id: stim, position },
            ]
        })

    })

    function triggerIframeReload() {
        inputRef.current.src = ''
        inputRef.current.src = src
    }

    function createIframeScr(iframeStep, baseSrc) {

        if (iframeStep) {

            const url = `${baseSrc}?step_id=${iframeStep}`
            setSrc(url)
        }

    }
    const history = useHistory();
    function confirmStep() {

        let path = `/my_studies/overview/${studyId}/cell_step_management`;
        history.push(path);
        // changeModalView()
    }





    /*
     * Removed with the slot fix:
     *
     *   checkIfStimPositionsAvailable  maintained stimPositionAvailable, which addStims was
     *                                 the only reader of. addStims now enforces one stim per
     *                                 slot directly, so the flag had no readers left.
     *
     *   checkStims                    compared slot letters ('a', 'b') against
     *                                 confirmationStimArray's numbers (0, 1), so its find()
     *                                 always matched the first entry and it could only ever
     *                                 call setCard(0). TableCardsWrapper's
     *                                 firstEmptySlotIndex() does the job it was aiming at.
     */

    useEffect(() => {
        const input = inputRef.current;
    }, []);

    useEffect(() => {
        createIframeScr(iframeStep, pg.cached_source)
    }, [stimsLoaded])


    const handleAddAll = async () => {
        try {
            const response = await onAddAll(selectedIds);
            setSelectedIds(false);
            return response
        } finally {
        }
    };

    return (
        <article style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-around', width: '100%' }}>

            <h1>
                Building cache page
            </h1>
            <h2> you have {pg.ad_count} ad slots</h2>
            <h3 style={{ margin: 0, fontWeight: 400 }}>device: {pg.device || 'not set'}</h3>

            <section style={{ display: 'flex', flexDirection: 'row', height: '100%', width: '100%', justifyContent: "space-around" }} >
                {/* In full screen the preview leaves the normal flow entirely. Sizing the
                    iframe to 100vh in place never actually filled the screen - the page
                    headings and the control bar above it pushed most of it below the fold. */}
                <article style={displayPreview ? {
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    zIndex: 1300,
                    background: '#fff',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 8,
                    padding: 12,
                    overflow: 'hidden',
                } : {
                    width: '500px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'space-around',
                    justifyContent: 'center',
                }}>
                    {/* i exist to access the redux store */}

                    <div
                        style={{
                            display: 'flex',
                            gap: 8,
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                            marginBottom: displayPreview ? 0 : '1rem',
                        }}
                    >
                        <button className="button-primary" onClick={triggerIframeReload}>reload iframe</button>

                        <button className="button-primary" onClick={() => setShowLumenPanel(true)}>
                            page elements
                        </button>

                        {/* deliberately outside the stim panel - it is the only way back once
                            the panel is minimised, and a control inside it would go with it */}
                        <button className="button-primary" onClick={togglePreview}>
                            {displayPreview ? 'exit full screen' : 'full screen page'}
                        </button>

                        {/* only offered once the backend has given us a step - without one the
                            iframe is still on the bare cached_source and there is nothing to preview */}
                        {iframeStep ? (
                            <button className="button-primary" onClick={() => openMobilePreview(src, pg.device)}>
                                device preview
                            </button>
                        ) : null}

                        {displayPreview ? (
                            <span style={{ fontSize: 12, color: 'rgb(99, 115, 129)' }}>
                                {pg.device || 'device not set'}{cachePgStep ? ` · step ${cachePgStep}` : ''}
                            </span>
                        ) : null}
                    </div>

                    <iframe ref={inputRef} src={src} onLoad={handleIframeLoad} style={{
                        ...(displayPreview && {
                            // fill whatever is left of the overlay - minHeight lets the flex
                            // item shrink instead of overflowing on a short viewport
                            flex: 1,
                            minHeight: 0,
                            width: '100%',
                            border: 0
                        }),
                        ...(!displayPreview && {
                            width: '100%', height: '100%'
                        })
                    }} >
                    </iframe>
                </article>


                {
                    /* hidden rather than unmounted, so minimising and restoring keeps the
                       search results, pagination and any in-progress selections intact */
                    (
                        <article style={{ height: "480px", overflow: "scroll", display: displayPreview ? 'none' : 'block' }}>

                            {stims && stims.length === pg.ad_count ? (
                                <>
                                </>
                            ) : (
                                <>
                                    <StimSearchTableTop
                                        textFieldLabel="Search stims"
                                        // the name term now joins the same applied filter set as
                                        // everything else, so StimSearchTableTop builds and fires
                                        // the request. This only keeps the redux term in step -
                                        // building a payload here too would replace the other
                                        // filters instead of combining with them.
                                        textFieldChange={(term) => {
                                            onSearch(term);
                                        }}
                                        createdFilteredStimList={createdFilteredStimList}
                                    />

                                    <Divider
                                        sx={{
                                            borderColor: "rgba(0,0,0,0.08)",
                                        }}
                                    />
                                </>

                            )}

                            {!hasSearched ? (
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "64px 0", color: "#888", fontSize: "14px" }}>
                                    <SearchIcon style={{ fontSize: 50, marginBottom: 20 }} />
                                    <span>Search for a Stim</span>
                                </div>
                            ) : (
                                <>
                                    <TableCardsWrapper
                                        stims={stims}
                                        pgStimCount={pg.ad_count}
                                        loading={loading}
                                        // data={data}
                                        data={availableStims}
                                        addStims={addStims}
                                        paginationState={paginationState}
                                        onPageChange={(newPage) => {
                                            setResultPg(newPage)
                                        }}
                                        onRowsPerPageChange={(resultNumber) => {
                                            setResultsNumber(resultNumber)
                                        }}
                                        setStims={setStims}
                                        card={card}
                                        setCard={setCard}
                                        togglePreview={togglePreview}
                                        displayPreview={displayPreview}
                                        handleAddAll={handleAddAll}
                                        studyId={studyId}
                                        cellId={cellId}
                                        triggerStimsLoaded={triggerStimsLoaded}
                                        triggerIframeReload={triggerIframeReload}
                                        updateStep={updateStep}
                                        setUpdateStep={setUpdateStep}
                                        searched={searched}
                                        cachePgStep={cachePgStep}
                                        setCachePgStep={setCachePgStep}
                                        styling={styling}
                                    />
                                </>
                            )}
                        </article>
                    )
                }
            </section >
            {cachePgStep ? (
                <section
                    style={{ display: 'flex', flexDirection: 'column' }}
                >

                    <h1>new cache page step {cachePgStep}</h1>


                    <section style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }} >

                        <button onClick={confirmStep}>
                            return to step management
                        </button>


                    </section>

                </section>

            ) : (

                <button onClick={changeModalView} >
                    close view
                </button>
            )
            }

            <LumenElementPanel
                open={showLumenPanel}
                onClose={() => setShowLumenPanel(false)}
                frameRef={inputRef}
                overrides={lumenOverrides}
                applyLumenOverrides={applyLumenOverrides}
            />

        </article >
    )
}
//redux
const mapDispatchToProps = (dispatch) => {
    return {
        updateLoading: () => dispatch(CellStepManagementOperations.updateLoading())
    }

};


export default connect(undefined, mapDispatchToProps)(BuildPgMain);